import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import BookingView from './page/Booking/booking/booking_view';
import PaymentSuccessPage from './page/Booking/Success/paymentSuccess';
import CheckoutView from './page/Booking/Checkout/checkout';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import LoginPage from './page/Login/login_view';
import Dashboard_View from './page/CSM/Dashboard/dashboard';
import Resgiter_view from './page/CSM/User/register';
import CheckIn_View from './page/CSM/checkIn/checkIn_view';
import TicketForm_View from './page/CSM/edit/editBooking_view';
import OldBoatRentalPlanner from './page/CSM/Boatmanagmet/timeslotmanage_view';
import NotFound404 from './page/error/error_view';
import BoatScheduleTable from './page/CSM/Boatmanagmet/test/test';
import EmployeeDashboard from './page/CSM/Boatmanagmet/employee/employee';
import ShipInventoryDashboard from './page/CSM/Boatmanagmet/boat/boatmanagmet';
import BoatForm_View from './page/CSM/Boatmanagmet/boat/boatForm_view';
import { I18nextProvider } from 'react-i18next';
import BookingInfoView from './page/Booking/bookingInfo/BookingInfoView';
import AppointmentCalendar from './page/room/dashboardRoom';
import DetailRoom_view from './page/room/detailRoom';
import DashboardRoomTable_view from './page/room/dashbordtableRoom';
import i18next from 'i18next';
import Cookies from 'js-cookie';
import Coupon_View from './page/CSM/discount_coupon/coupon_view';
import CouponDashBord from './page/CSM/discount_coupon/couponDashbord_view';

function App() {

  const language = Cookies.get('language');

  const theme = createTheme({
    typography: {
      fontFamily: 'Noto Sans Thai, sans-serif',
    },
    // คุณสามารถปรับแต่งอื่นๆ ในธีมนี้ได้เช่นกัน เช่นสีหลัก (palette)
  });
  i18next.init({
    interpolation: { escapeValue: false }, // React already does escaping
    lng: language || 'TH', // ภาษาเริ่มต้น
    resources: {
      EN: {
        booking: require('./utility/locales/en/booking.json'),
        booking_appbar: require('./utility/locales/en/boooking_appbar.json'),
        popup_promo : require('./utility/locales/en/popup_promo.json'),
        condition : require('./utility/locales/en/condition.json'),
        checkout : require('./utility/locales/en/checkout.json'),
        success : require('./utility/locales/en/success.json')
      },
      TH: {
        booking: require('./utility/locales/th/booking.json'),
        booking_appbar: require('./utility/locales/th/boooking_appbar.json'),
        popup_promo : require('./utility/locales/th/popup_promo.json'),
        condition : require('./utility/locales/th/condition.json'),
        checkout : require('./utility/locales/th/checkout.json'),
        success : require('./utility/locales/th/success.json')
      }
    }
  });
  return (
    <I18nextProvider i18n={i18next}>
      <ThemeProvider theme={theme}>
        <Router>
          <Routes>
            <Route path="/" element={<BookingView />} />

            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgotpassword/:id" element={<LoginPage />} />
            {/* <Route path="/thewonderblueadmin_coupon" element={<CouponDashBord />} />
            <Route path="/thewonderblueadmin_coupon/view/:id" element={<Coupon_View />} />
            <Route path="/thewonderblueadmin_coupon/create/:id" element={<Coupon_View />} />
            <Route path="/thewonderblueadmin_coupon/edit/:id" element={<Coupon_View />} />
             */}

            <Route path="/thewonderblueadmin_admin" element={<Dashboard_View />} />
            {/* <Route path="/admin" element={<CSMTable />} /> */}
            <Route path="/thewonderblueadmin_register" element={<Resgiter_view />} />
            <Route path="/thewonderblueadmin_edit/:id" element={<TicketForm_View />} />
            <Route path="/thewonderblueadmin_checkin" element={<CheckIn_View />} />
            <Route path="/thewonderblueadmin_booking/create" element={<TicketForm_View />} />
            <Route path="/thewonderblueadmin_booking/version/:ver/id/:id" element={<TicketForm_View  />} />
            {/* <Route path="/admin/BoatPlaner" element={<BoatRentalPlanner />} /> */}
            <Route path="/thewonderblueadmin_BoatPlaner" element={<OldBoatRentalPlanner />} />
            <Route path="/thewonderblueadmin_boatmangement" element={<ShipInventoryDashboard />} />
            <Route path="/thewonderblueadmin_boat/create" element={<BoatForm_View />} />
            <Route path="/thewonderblueadmin_boat/:id" element={<BoatForm_View />} />


            <Route path='/booking/:id' element={<BookingInfoView />} />
            <Route path="/success/:id" element={<PaymentSuccessPage />} />
            <Route path="/checkout" element={<CheckoutView />} />

            <Route path="*" element={<BookingView />} />
            <Route path="/404" element={<NotFound404 />} />
            <Route path="/thewonderblueadmin_employee" element={<EmployeeDashboard />} />
            <Route path="/thewonderblueadmin_employee/view/:id" element={<Resgiter_view />} />

            <Route path="/thewonderblueadmin_room/dashboard" element={<AppointmentCalendar />} />
            <Route path="/thewonderblueadmin_room/create" element={<DetailRoom_view />} />
            <Route path="/thewonderblueadmin_room/view/:id" element={<DetailRoom_view />} />
            <Route path="/thewonderblueadmin_room" element={<DashboardRoomTable_view />} />
          </Routes>
        </Router>
      </ThemeProvider>
    </I18nextProvider>
  );
}

export default App;